var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.64,
    height: 11.551,
    viewBox: "0 0 11.64 11.551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4175df;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M29.9,8.947h.365a.382.382,0,0,1,.383.383v1.985a.382.382,0,0,1-.383.383H29.9a.381.381,0,0,1-.382-.383V9.33A.381.381,0,0,1,29.9,8.947Zm-3.725-.389c-.182,0-.317.078-.317.292v2.88a.488.488,0,0,0,.494.493H30.97a.487.487,0,0,0,.492-.493V8.868c0-.283-.165-.31-.629-.31H26.175Z",
    transform: "translate(-23.011 -8.558)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.42,11.569l-2-2.163c-.276-.3-.328-.191-.328.118V12.1a1.056,1.056,0,0,1-.951,1.051H11.071a1.1,1.1,0,0,1-1-1.051V8.819C8.159,9.035,8,10.124,8,11.182v7.933a1.293,1.293,0,0,0,1.366,1.213h9.051a1.171,1.171,0,0,0,1.223-1.213V12.169A.621.621,0,0,0,19.42,11.569Zm-2.013,6.609a.715.715,0,0,1-.715.715H11.107a.715.715,0,0,1-.715-.715v-1.6a.715.715,0,0,1,.715-.715h5.586a.715.715,0,0,1,.715.715Z",
    transform: "translate(-8 -8.777)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/save_icon.2d5e889f1bfd1f48d9188369b56a9956.svg";
export { ForwardRef as ReactComponent };